<!-- @description: 通联支付组件 -->
<script lang="ts" setup>
import QRCode from 'qrcode'
import { ref, onMounted } from 'vue'

const props = defineProps<{
  createOrder: () => Promise<any>
}>()

const loading = ref(false)
const qrCodeUrl = ref('')
const createQrCode = async (url: string) => {
  return QRCode.toDataURL(url, {
    margin: 0,
    width: 160,
  })
}
const loadQrCode = async () => {
  loading.value = true
  const result = await props.createOrder()
  qrCodeUrl.value = await createQrCode(result.result_data || '')
}

onMounted(async () => {
  try {
    await loadQrCode()
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div :class="$style.qrCodeImageContainer">
    <img v-show="!loading" :class="$style.qrCodeImage" :src="qrCodeUrl" alt="qr-code" />
  </div>
</template>

<style lang="scss" module>
.qrCodeImageContainer {
  position: relative;
  width: 100%;
}

.qrCodeImage {
  width: 100%;
  height: auto;
}

:global(.mobile-mode) {
  .qrCodeImageContainer {
    margin: 12px 0;
  }
}
</style>
